import Vue from 'vue'
import Vuex from 'vuex'
import common from "./modules/common.js"
import mobile from "./modules/mobile.js"
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    count: 1,
    getUserInfo: 0,
    device: {},
    token:""
  },
  mutations: {
    login(state, provider) {
      state.login = true;
      state.token = provider.token;
      state.userName = provider.userName;
      state.avatarUrl = provider.avatarUrl;
    },
    logout(state) {
      state.login = false;
      state.token = '';
      state.userName = '';
      state.avatarUrl = '';
    },




  },

  getters: {
    // 练习
    getStateCount(state) {
      return state.count + 1
    },
    // 获取todo列表
    getTodo: (state) => {
      return state.todos
    },
    // 获取TODO列表中done为true
    getTodoDonesTrue: (state) => (id) => {
      return state.todos.filter(todos => todos.done)
    },
    // 获取id为2的一组值 
    getTodoById: (state) => (id) => {
      return state.todos.filter(todos => todos.id === id)
    }
  },
  mutations: {
    add(state) {
      state.count = state.count + 1
    },
    reduce(state, n) {
      state.count = state.count - n
    },
    getDevice(state, n) {
      state.device = JSON.parse(n)
    },
    getToken(state, n) {
      state.token = n
    },
  },
  actions: {
    increment(context) {
      context.commit('login')
    },
    addFuns(context) {
      context.commit("add")
    },
    reduceFuns(context, n) {
      context.commit("reduce", n)
    },
    getDeviceFuns(context, n) {
      context.commit("getDevice", n)
    },
    getTokenFuns(context, n) {
      context.commit("getToken", n)
    },
  },
  modules: {
    common,
    mobile
  }

})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js